import $ from 'jquery';
import '../packages/choices/choices';

export default class Select {
    constructor($element, options) {
        this.$element = $element;
        this.options = $.extend(true, options, {
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            allowHTML: true
        });
        this.select = null;

        this.build();
    }

    showDropdown() {
        document.body.classList.add('select-expanded');

        if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) {
            document.body.classList.add('scroll-hide');

            const $list = document.querySelector('.choices__list.is-active');

            if ($list.getAttribute('data-repaint') === 'true') {
                return;
            }

            $list.style.display = 'none';

            setTimeout(() => {
                $list.style.display = 'block';
                $list.setAttribute('data-repaint', 'true');
            }, 0);
        }
    }

    hideDropdown() {
        document.body.classList.remove('select-expanded');

        if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) {
            document.body.classList.remove('scroll-hide');
        }
    }

    build() {
        const choice = this.select = new Choices(this.$element, this.options);

        choice.passedElement.element.addEventListener('showDropdown', () => this.showDropdown());
        choice.passedElement.element.addEventListener('hideDropdown', () => this.hideDropdown());
    }

}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/select.js